import React from "react";

export default function useDebounced(
  state: unknown,
  delay?: number
) {
  const [debouncedValue, setDebouncedValue] = React.useState(state)
  React.useEffect(() => {
    let timeoutId = setTimeout(() => {
      setDebouncedValue(state)
    }, delay)
    return () => clearTimeout(timeoutId)
  }, [state])
    
  return {debouncedValue, setDebouncedValue};
}
